<template>
  <div class="alert" :class="alertType" role="alert">
    <span :class="'color-' + contentsColor">
      <slot>
        <span>{{ message }}</span>
      </slot>
    </span>
    <Btn
      class="close"
      variant="link"
      data-dismiss="alert"
      aria-label="Close"
      v-if="dismissible"
      @click="close"
    >
      <Icon icon="close" :size="10" :color="contentsColor" />
    </Btn>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import { computed } from "@vue/composition-api";
import Icon from "@/components/display/icon/Icon";

export default {
  name: "Alert",
  components: {
    Icon,
    Btn,
  },
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    message: String,
    id: [Number, String],
    dismissible: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const typeList = {
      primary: "alert-primary",
      secondary: "alert-secondary",
      success: "alert-success",
      danger: "alert-danger",
      warning: "alert-warning",
      info: "alert-info",
      light: "alert-light",
      dark: "alert-dark",
      link: "alert-link",
    };

    const alertType = computed(() => {
      return typeList[props.variant];
    });

    const contentsColor = computed(() => {
      let color;
      switch (props.variant) {
        case "warning":
          color = "alpha";
          break;
        case "info":
          color = "alpha";
          break;
        case "light":
          color = "alpha";
          break;
        default:
          color = "beta";
      }
      return color;
    });

    const close = () => {
      emit("close", { message: props.message, id: props.id });
    };

    return {
      alertType,
      close,
      contentsColor,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.alert {
  font-size: 0.75rem;
  .close {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 100;
    position: relative;
    left: 10px;
  }
}
</style>
